import { render, staticRenderFns } from "./ConversationFiles.vue?vue&type=template&id=0f89ee49&"
import script from "./ConversationFiles.vue?vue&type=script&lang=js&"
export * from "./ConversationFiles.vue?vue&type=script&lang=js&"
import style0 from "./ConversationFiles.vue?vue&type=style&index=0&id=0f89ee49&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports